import BaseItem from './base_item';

export default class Server extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "server.png");
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 15; }
    static get height() { return 8; }

    static get mass() { return 2; }
    static get electronic() { return true; }


    static get type() { return 'server' }
    static get label() { return 'server box' }
    static get description() {
        return `It's an old data server. You used to host some gamedev jams on it.`}
}


// WEBPACK FOOTER //
// ./src/objects/items/server.js